import { render } from "./Home_Changelog.vue?vue&type=template&id=207a9907&scoped=true&lang=pug"
import script from "./Home_Changelog.vue?vue&type=script&lang=js"
export * from "./Home_Changelog.vue?vue&type=script&lang=js"

import "./Home_Changelog.vue?vue&type=style&index=0&id=207a9907&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207a9907"]])

export default __exports__